import store from '@store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@views/Login.vue'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/resetPwd',
        name: 'resetPwd',
        component: () => import('@views/ResetPwd.vue'),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/',
        component: () => import('@layouts/Main.vue'),
        meta: {
            authRequired: true,
        },
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('@views/Home.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'home',
                },
            },
            {
                path: 'documents',
                name: 'documents',
                component: () => import('@views/ged/GedView.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'ged',
                },
            },
            {
                path: 'search-documents',
                name: 'searchDocuments',
                component: () => import('@views/ged/GedSearchView.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'ged',
                },
            },
            {
                path: 'forecast/list',
                name: 'forecastList',
                component: () => import('@views/forecast/ForecastList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'forecast/create',
                name: 'forecastCreate',
                component: () => import('@views/forecast/ForecastCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'forecast/:id/update',
                name: 'forecastUpdate',
                component: () => import('@views/forecast/ForecastUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'forecast/:id/details',
                name: 'forecastDetails',
                component: () => import('@views/forecast/ForecastDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'link/list',
                name: 'linkList',
                component: () => import('@views/link/LinkList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'link/create',
                name: 'linkCreate',
                component: () => import('@views/link/LinkCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'link/:id/update',
                name: 'linkUpdate',
                component: () => import('@views/link/LinkUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'link/:id/details',
                name: 'linkDetails',
                component: () => import('@views/link/LinkDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'summary/daily/classic/list',
                name: 'classicDailySummaryList',
                component: () => import('@views/summary/ClassicDailySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'summary/daily/modernized/list',
                name: 'modernizedDailySummaryList',
                component: () => import('@views/summary/ModernizedDailySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'summary/weekly/list',
                name: 'weeklySummaryList',
                component: () => import('@views/summary/WeeklySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/list',
                name: 'bilanCondTravailList',
                component: () => import('@views/bilan/condtravail/BilanCondTravailList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/synthese',
                name: 'bilanCondTravailSynthese',
                component: () => import('@views/bilan/condtravail/BilanCondTravailSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/create',
                name: 'bilanCondTravailCreate',
                component: () => import('@views/bilan/condtravail/BilanCondTravailCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/:id/update',
                name: 'bilanCondTravailUpdate',
                component: () => import('@views/bilan/condtravail/BilanCondTravailUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/:id/details',
                name: 'bilanCondTravailDetails',
                component: () => import('@views/bilan/condtravail/BilanCondTravailDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/list',
                name: 'bilanCriseList',
                component: () => import('@views/bilan/crise/BilanCriseList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/synthese',
                name: 'bilanCriseSynthese',
                component: () => import('@views/bilan/crise/BilanCriseSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/create',
                name: 'bilanCriseCreate',
                component: () => import('@views/bilan/crise/BilanCriseCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/period/create',
                name: 'bilanCrisePeriodCreate',
                component: () => import('@views/bilan/crise/BilanCrisePeriodCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/:id/update',
                name: 'bilanCriseUpdate',
                component: () => import('@views/bilan/crise/BilanCriseUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/period/:id/update',
                name: 'bilanCrisePeriodUpdate',
                component: () => import('@views/bilan/crise/BilanCrisePeriodUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/:id/details',
                name: 'bilanCriseDetails',
                component: () => import('@views/bilan/crise/BilanCriseDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/period/:id/details',
                name: 'bilanCrisePeriodDetails',
                component: () => import('@views/bilan/crise/BilanCrisePeriodDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/list',
                name: 'bilanFormationList',
                component: () => import('@views/bilan/formation/BilanFormationList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/synthese',
                name: 'bilanFormationSynthese',
                component: () => import('@views/bilan/formation/BilanFormationSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/create',
                name: 'bilanFormationCreate',
                component: () => import('@views/bilan/formation/BilanFormationCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/:id/update',
                name: 'bilanFormationUpdate',
                component: () => import('@views/bilan/formation/BilanFormationUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/:id/details',
                name: 'bilanFormationDetails',
                component: () => import('@views/bilan/formation/BilanFormationDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/list',
                name: 'bilanMaterielList',
                component: () => import('@views/bilan/materiel/BilanMaterielList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/synthese',
                name: 'bilanMaterielSynthese',
                component: () => import('@views/bilan/materiel/BilanMaterielSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/create',
                name: 'bilanMaterielCreate',
                component: () => import('@views/bilan/materiel/BilanMaterielCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/:id/update',
                name: 'bilanMaterielUpdate',
                component: () => import('@views/bilan/materiel/BilanMaterielUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/:id/details',
                name: 'bilanMaterielDetails',
                component: () => import('@views/bilan/materiel/BilanMaterielDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/circuit/list',
                name: 'bilanCircuitList',
                component: () => import('@views/bilan/circuit/BilanCircuitList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/circuit/synthese',
                name: 'bilanCircuitSynthese',
                component: () => import('@views/bilan/circuit/BilanCircuitSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
            
                },
            },
            {
                path: 'bilan/circuit/create',
                name: 'bilanCircuitCreate',
                component: () => import('@views/bilan/circuit/BilanCircuitCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/circuit/:id/update',
                name: 'bilanCircuitUpdate',
                component: () => import('@views/bilan/circuit/BilanCircuitUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/circuit/:id/:year/details',
                name: 'bilanCircuitDetails',
                component: () => import('@views/bilan/circuit/BilanCircuitDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'intervention/list',
                name: 'interventionList',
                component: () => import('@views/intervention/InterventionList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                },
            },
            {
                path: 'intervention/:id/details',
                name: 'interventionDetails',
                component: () => import('@views/intervention/InterventionDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                },
            },
            {
                path: 'intervention/:id/update',
                name: 'interventionUpdate',
                component: () => import('@views/intervention/InterventionUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                },
            },
            {
                path: 'intervention/create',
                name: 'interventionCreate',
                component: () => import('@views/intervention/InterventionUpdate.vue'),
                meta: {
                    authRequired: true,
                    creation: true,
                    topbarMenu: 'intervention',
                },
            },
            {
                path: 'actualite',
                name: 'actualiteList',
                component: () => import('@views/actualite/ActualiteList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/ager',
                name: 'agerList',
                component: () => import('@views/admin/ager/AgerList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/uer',
                name: 'uerList',
                component: () => import('@views/admin/uer/UerList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/cei',
                name: 'ceiList',
                component: () => import('@views/admin/cei/CeiList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/circuit',
                name: 'circuitList',
                component: () => import('@views/admin/circuit/CircuitList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/userGroup',
                name: 'userGroupList',
                component: () => import('@views/admin/usergroup/UserGroupList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/user',
                name: 'userList',
                component: () => import('@views/admin/user/UserList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/agent',
                name: 'agentList',
                component: () => import('@views/admin/agent/AgentList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/axeintervention',
                name: 'axeInterventionList',
                component: () => import('@views/admin/axeintervention/AxeInterventionList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'epi/admin/epiactivite',
                name: 'epiActiviteList',
                component: () => import('@views/epi/admin/epiActivite/EpiActiviteList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/admin/epiarticle',
                name: 'epiArticleList',
                component: () => import('@views/epi/admin/epiArticle/EpiArticleList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/admin/epifournisseur',
                name: 'epiFournisseurList',
                component: () => import('@views/epi/admin/epiFournisseur/EpiFournisseurList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/admin/epirubrique',
                name: 'epiRubriqueList',
                component: () => import('@views/epi/admin/epiRubrique/EpiRubriqueList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/admin/epitaille',
                name: 'epiTailleList',
                component: () => import('@views/epi/admin/epiTaille/EpiTailleList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epibonretrait',
                name: 'epiBonRetraitList',
                component: () => import('@views/epi/epiBonRetrait/EpiBonRetraitList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epistock',
                name: 'epiStockList',
                component: () => import('@views/epi/epiStock/EpiStockList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epistock/update',
                name: 'epiStockUpdate',
                component: () => import('@views/epi/epiStock/EpiStockUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidotationcustom/edit/:userId/:ruleId',
                name: 'epiDotationCustomEdit',
                component: () => import('@views/epi/epiDotationCustom/EpiDotationCustomEdit.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidotationreelle/edit/:userId',
                name: 'epiDotationReelleEdit',
                component: () => import('@views/epi/epiDotationReelle/EpiDotationReelleEdit.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidotationreelle/import',
                name: 'epiDotationReelleImport',
                component: () => import('@views/epi/epiDotationReelle/EpiDotationReelleImport.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epistock/alerteupdate',
                name: 'epiStockAlerteUpdate',
                component: () => import('@views/epi/epiStock/EpiStockAlerteUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epibonretrait/create',
                name: 'epiBonRetraitCreate',
                component: () => import('@views/epi/epiBonRetrait/EpiBonRetraitCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epibonretrait/dispatch/:id',
                name: 'epiBonRetraitDispatch',
                component: () => import('@views/epi/epiBonRetrait/EpiBonRetraitDispatch.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epibonretrait/:id',
                name: 'epiBonRetraitDetail',
                component: () => import('@views/epi/epiBonRetrait/EpiBonRetraitDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidemande',
                name: 'epiDemandeList',
                component: () => import('@views/epi/epiDemande/EpiDemandeList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidemandesynthese',
                name: 'epiDemandeSynthese',
                component: () => import('@views/epi/epiDemande/EpiDemandeSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidemande/:id',
                name: 'epiDemandeDetail',
                component: () => import('@views/epi/epiDemande/EpiDemandeDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epidemande/create',
                name: 'epiDemandeCreate',
                component: () => import('@views/epi/epiDemande/EpiDemandeCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epipredemande/:id',
                name: 'epiPreDemandeDetail',
                component: () => import('@views/epi/epiPreDemande/EpiPreDemandeDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epipredemande/create',
                name: 'epiPreDemandeCreate',
                component: () => import('@views/epi/epiPreDemande/EpiPreDemandeCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiretour',
                name: 'epiRetourList',
                component: () => import('@views/epi/epiRetour/EpiRetourList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiretour/:id',
                name: 'epiRetourDetail',
                component: () => import('@views/epi/epiRetour/EpiRetourDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiretour/create',
                name: 'epiRetourCreate',
                component: () => import('@views/epi/epiRetour/EpiRetourCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epipreretour/:id',
                name: 'epiPreRetourDetail',
                component: () => import('@views/epi/epiPreRetour/EpiPreRetourDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epipreretour/create',
                name: 'epiPreRetourCreate',
                component: () => import('@views/epi/epiPreRetour/EpiPreRetourCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epicommande',
                name: 'epiCommandeList',
                component: () => import('@views/epi/epiCommande/EpiCommandeList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epicommande/:id',
                name: 'epiCommandeDetail',
                component: () => import('@views/epi/epiCommande/EpiCommandeDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epicommande/:id/update',
                name: 'epiCommandeUpdate',
                component: () => import('@views/epi/epiCommande/EpiCommandeUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epicommande/create',
                name: 'epiCommandeCreate',
                component: () => import('@views/epi/epiCommande/EpiCommandeCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epimouvement',
                name: 'epiMouvementList',
                component: () => import('@views/epi/epiMouvement/EpiMouvementList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epimouvement/create',
                name: 'epiMouvementCreate',
                component: () => import('@views/epi/epiMouvement/EpiMouvementCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epimouvement/:id',
                name: 'epiMouvementDetail',
                component: () => import('@views/epi/epiMouvement/EpiMouvementDetail.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'help',
                name: 'help',
                component: () => import('@views/help/help.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'help',
                },
            },
            {
                path: 'profile',
                name: 'myProfile',
                component: () => import('@views/user/MyProfile.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'profile/:id',
                name: 'userProfile',
                component: () => import('@views/user/Profile.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'unauthorized',
                name: 'unauthorized',
                component: require('@views/core/_unauthorized.vue').default,
                // Allows props to be passed to the 404 page through route
                // params, such as `resource` to define what wasn't found.
                props: true,
            },
            {
                path: '/charte',
                name: 'charte',
                component: () => import('@views/charte/Charte.vue'),
                meta: {
                    authRequired: true
                }
            },
        ]
    },
    {
        path: '/404',
        name: '404',
        component: require('@views/core/_404.vue').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '404',
    },
]